import { handleActions } from 'redux-actions';

import { fetchingLocalizations, localizationsFetched, loginOnlyBySsoView, loadingConfiguration, configurationLoaded } from '../actions/app';
import { fetchingStaticData, staticDataFetched } from '../actions/ehrResources';
import { restoreInitialState } from '../actions/session';

const initialState = {
  loadingLocalizations: true,
  localizationsLoaded: false,
  loadingStaticData: false,
  staticDataLoaded: false,
  showLoginOnlyBySsoView: false,
  loadingConfiguration: false,
  configurationLoaded: false
};

const appReducer = handleActions({
  [fetchingLocalizations]: state => ({
    ...state,
    loadingLocalizations: true,
    localizationsLoaded: false
  }),
  [localizationsFetched]: state => ({
    ...state,
    loadingLocalizations: false,
    localizationsLoaded: true,
  }),
  [fetchingStaticData]: state => ({
    ...state,
    loadingStaticData: true,
    staticDataLoaded: false
  }),
  [staticDataFetched]: state => ({
    ...state,
    loadingStaticData: false,
    staticDataLoaded: true
  }),
  [restoreInitialState]: state => ({
    ...state,
    loadingStaticData: false,
    staticDataLoaded: false
  }),
  [loginOnlyBySsoView]: state => ({
    ...state,
    showLoginOnlyBySsoView: true
  }),
  [loadingConfiguration]: state => ({
    ...state,
    loadingConfiguration: true,
    configurationLoaded: false
  }),
  [configurationLoaded]: state => ({
    ...state,
    configurationLoaded: true,
    loadingConfiguration: false
  })
}, initialState);

export default appReducer;



// WEBPACK FOOTER //
// ./src/reducers/app.js